import store from '@/store';

const exitModal = (
  mode: string,
  updateOngoingProjects?: boolean,
  updateReports?: boolean,
): void => {
  store.commit('setModalOpen', false);

  if (store.state.assessmentsFilter.projects === 'ongoing' && updateOngoingProjects) {
    setTimeout(() => {
      store.commit('setReloadSpecificList', 'projects');
    }, 1500);
  }

  if (updateReports) {
    setTimeout(
      () => {
        store.commit('setReloadSpecificList', 'reports');
      },
      updateOngoingProjects ? 2000 : 1500,
    );
  }

  setTimeout(() => {
    store.commit('setReloadSpecificList', mode);
    document
      .querySelectorAll('.modal__header__close')
      .forEach((closeIcon) => (closeIcon as HTMLElement).click());
  }, 1000);
};

export default exitModal;
